import Cookie from "js-cookie";

let apiKey = "kKYjV86tSM-4xlgb5Mv8Tg";
let apiSecret = "eGi9fQEieohBiY2uRx4PeF2sCB239Zcja6Qc";
// let meetingNumber = "8065015548"
let role = 0;
let leaveUrl = `${process.env.NEXT_PUBLIC_ORIGIN}/classes/enrolled`;
let userName = Cookie.get("student_name");
let userEmail = Cookie.get("student_email");

export const initZoom = async (meetingNumber, passWord) => {
  console.log("meeting id at lauch ", meetingNumber);
  const { ZoomMtg } = await import("@zoomus/websdk");
  // Recoil
  if (typeof ZoomMtg !== "undefined") {
    ZoomMtg.setZoomJSLib("https://source.zoom.us/1.8.5/lib", "/av");
    ZoomMtg.preLoadWasm();
    ZoomMtg.prepareJssdk();

    document.getElementById("zmmtg-root").style.display = "block";
    document.getElementById("zmmtg-root").style.zIndex = "9999";

    ZoomMtg.generateSignature({
      meetingNumber,
      apiKey,
      apiSecret,
      role: role?.toString(),
      success(res: any) {
        if (typeof ZoomMtg.init !== undefined) {
          ZoomMtg.init({
            // disableInvite: true,
            leaveUrl,
            isSupportAV: true,
            sharingMode: "fit",
            showPureSharingContent: true,
            success() {
              ZoomMtg.join({
                meetingNumber,
                userName,
                userEmail,
                signature: res.result,
                passWord,
                apiKey,
                success() {
                  console.debug("join meeting success");
                },
                error(res: any) {
                  console.debug(res);
                },
              });
              console.debug(res);
            },
            error(res: any) {
              console.debug(res);
            },
          });
        }
      },
      error(res: any) {
        console.debug(res);
      },
    });
  }
};

// const Live = () => {
//   const { loggedIn, studentData } = useRecoilValue(authData);
//   // Recoil
//   React.useEffect(() => {
//     // init();
//   });

//   return (
//     <UserLayoutv2
//       title="Live"
//       customLeftWidth={{ base: "0%", lg: "20%" }}
//       left={
//         <Fragment>
//           {loggedIn ? (
//             <LoggedInActionLinks classesData={studentData.joined_classes} />
//           ) : (
//             <Box
//               h="100%"
//               py={10}
//               // px={12}
//             ></Box>
//           )}
//         </Fragment>
//       }
//       customMainWidth={loggedIn ? { base: "100%", lg: "60%" } : { base: "100%", lg: "80%" }}
//       main={
//         <Box pb={12} mb={6} px={{ base: 4, lg: 16 }} h="100%" w="100%">
//           <Button colorScheme="blue" variant="solid" borderRadius="8px" size="lg" margin="auto" onClick={() => initZoom('123', '123')}>
//             Start
//           </Button>
//         </Box>
//       }
//       customRightWidth={loggedIn ? { base: "0%", lg: "20%" } : "0"}
//       right={<Box d={loggedIn ? { base: "none", lg: "block" } : "none"} h="100%" pt={10} pl={6}></Box>}
//     />
//   );
// };

// export default Live;
